// Derives the current user's capabilities for campaigns. Consumed by
// NewCampaignButton, CampaignRow, DangerZone, etc. Never scatter role checks
// across the component tree — always go through this hook.

import { useMemo } from 'react';
import { useUserRole } from '../../auth/hooks';
import { useFeatures } from '../../settings/hooks/useSettingsState';
import { capabilitiesForRole } from '../permissions';
import { FEATURE_FLAG } from '../constants';

export const useCampaignPermissions = () => {
  const role = useUserRole();
  const features = useFeatures();

  return useMemo(() => {
    const base = capabilitiesForRole(role);
    const featureEnabled = !!features?.[FEATURE_FLAG.CAMPAIGNS];

    if (!featureEnabled) {
      // Feature flag off — everybody loses access regardless of role.
      return { ...base, featureEnabled: false, canViewList: false, canCreate: false };
    }

    return { ...base, featureEnabled: true, role };
  }, [role, features]);
};
